import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { ShoppingBag, Menu, X, Phone } from "lucide-react";
import { useCart } from "../context/CartContext";

import { LOGO_IMAGE as LOGO_URL } from "../lib/siteImages";

const NAV_LINKS = [
  { to: "/shop/alcohol", label: "Alcool" },
  { to: "/shop/soft_drinks", label: "Soft Drinks" },
  { to: "/shop/water", label: "Eaux" },
  { to: "/shop/snacks", label: "Snacks" },
  { to: "/shop/planches", label: "Planches" },
  { to: "/shop/restauration", label: "Restauration" },
  { to: "/shop/tobacco", label: "Tabac" },
];

export const Navbar = () => {
  const { count, setOpen } = useCart();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="glass-nav sticky top-0 z-40">
      <div className="container-x px-5 sm:px-8 h-20 sm:h-24 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo-link">
          <img src={LOGO_URL} alt="Noctua Riviera" width="1024" height="1024" className="h-12 sm:h-16 w-auto" data-testid="nav-logo-image" />
          <div className="hidden sm:flex flex-col leading-none">
            <span className="font-display text-lg text-white tracking-wider">NOCTUA</span>
            <span className="eyebrow text-[10px] mt-0.5">Riviera</span>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              data-testid={`nav-link-${link.to.split("/").pop()}`}
              className={({ isActive }) =>
                `text-sm tracking-wider uppercase transition-colors ${
                  isActive ? "text-[#d4af37]" : "text-gray-300 hover:text-[#d4af37]"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2 sm:gap-4">
          <a
            href="tel:+33623060308"
            className="hidden sm:inline-flex items-center gap-2 text-xs uppercase tracking-wider text-gray-300 hover:text-[#d4af37] transition-colors"
            data-testid="nav-call-btn"
          >
            <Phone size={14} />
            06 23 06 03 08
          </a>
          <button
            onClick={() => setOpen(true)}
            className="relative btn-ghost p-2"
            data-testid="nav-cart-btn"
            aria-label="Panier"
          >
            <ShoppingBag size={20} className="text-white" />
            {count > 0 && (
              <span
                className="absolute -top-0.5 -right-0.5 bg-[#d4af37] text-[#0a0f1a] text-[10px] font-bold w-5 h-5 flex items-center justify-center"
                data-testid="cart-count"
              >
                {count}
              </span>
            )}
          </button>
          <button
            className="lg:hidden btn-ghost p-2"
            onClick={() => setMobileOpen(!mobileOpen)}
            data-testid="nav-mobile-toggle"
            aria-label="Menu"
          >
            {mobileOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="lg:hidden border-t border-subtle bg-[#0a0f1a]" data-testid="mobile-menu">
          <nav className="container-x px-5 py-5 flex flex-col gap-1">
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                onClick={() => setMobileOpen(false)}
                data-testid={`mobile-nav-link-${link.to.split("/").pop()}`}
                className={({ isActive }) =>
                  `py-3 px-2 text-sm uppercase tracking-wider border-b border-white/5 ${
                    isActive ? "text-[#d4af37]" : "text-gray-300"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
            <a
              href="tel:+33623060308"
              className="py-3 px-2 mt-3 text-sm uppercase tracking-wider text-[#d4af37] flex items-center gap-2"
            >
              <Phone size={16} /> 06 23 06 03 08
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};
